import React from 'react';
import { Button, Dialog, DialogContent, DialogFooter, DialogWidth } from '@tcc/fds';
import { getMessage } from '@tcc/i18n';
import styles from './firstLoginVideoDialog.css';

const VIDEO_URL = 'https://www.youtube.com/embed/YmiPck7B3NQ?autoplay=1&rel=0&modestbranding=1&playsinline=1&enablejsapi=1';

interface FirstLoginVideoDialogProps {
  isOpen?: boolean;
  onClose: () => void;
}

export const FirstLoginVideoDialog = ({ isOpen = false, onClose }: FirstLoginVideoDialogProps) => (
  <Dialog
    testId="first-login-video-dialog"
    headerProps={{ title: getMessage('firstLoginVideo.dialog.title') }}
    isModal
    closeOnOutsideClick={false}
    width={DialogWidth.Wide}
    open={isOpen}
    onOpenChange={(open) => {
      if (!open) {
        onClose();
      }
    }}
  >
    <DialogContent width='100%'>
      <iframe
        className={styles.videoFrame}
        src={VIDEO_URL}
        title={getMessage('firstLoginVideo.dialog.videoTitle')}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </DialogContent>
    <DialogFooter>
      <Button onClick={onClose} testId="first-login-video-dialog-continue-button">
        {getMessage('firstLoginVideo.dialog.continue')}
      </Button>
    </DialogFooter>
  </Dialog>
);
